import { FC, useMemo } from 'react';
import Select from '../select';
import { FormProps } from '../helpers';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { getSensitiveDataActionOptions } from '@/lib/models/policy-model/sensitive-data';
import { getFormattedUiOptions } from '../select/helpers';

interface Props extends FormProps {
  value: string;
  onChange: (value: string) => void;
  defaultPolicy?: PolicyModel;
}

const SdActionSelect: FC<Props> = ({ value, onChange, defaultPolicy, ...rest }) => {
  const actionOpts = useMemo(() => {
    const options = getSensitiveDataActionOptions(defaultPolicy);
    return getFormattedUiOptions(options);
  }, [defaultPolicy]);

  const props = {
    ...rest,
    value,
    onChange,
    options: actionOpts,
    label: '',
  };

  return <Select {...props} size="small" />;
};

export default SdActionSelect;
